module.exports = __webpack_public_path__ + "static/trees_night_mobile-37f9fd4ef92167fc5aa44032e87f5c8c.jpg";